import React from 'react';

// Navigation glyphs from the v6 Exams prototype.
const glyphs = {
  'My Drafts': (
    <>
      <path d="M12 20h9"></path>
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"></path>
    </>
  ),
  'Class Tasks': (
    <>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="8" y1="13" x2="16" y2="13"></line>
      <line x1="8" y1="17" x2="14" y2="17"></line>
    </>
  ),
  Exams: (
    <>
      <rect x="5" y="3" width="14" height="18" rx="2"></rect>
      <path d="M9 3h6v3H9z"></path>
      <polyline points="8.5 12 10.5 14 15.5 9.5"></polyline>
      <line x1="8.5" y1="17.5" x2="15.5" y2="17.5"></line>
    </>
  ),
  'Class Insights': (
    <>
      <rect x="3" y="3" width="18" height="18" rx="3"></rect>
      <line x1="8" y1="16" x2="8" y2="12"></line>
      <line x1="12" y1="16" x2="12" y2="8"></line>
      <line x1="16" y1="16" x2="16" y2="11"></line>
    </>
  ),
  'Marking Tools': (
    <>
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </>
  ),
  'Study Guides': (
    <>
      <path d="M2 4h7a3 3 0 0 1 3 3v13a2 2 0 0 0-2-2H2z"></path>
      <path d="M22 4h-7a3 3 0 0 0-3 3v13a2 2 0 0 1 2-2h8z"></path>
    </>
  ),
};

export default function ExamsNavIcon({ name, active }) {
  const glyph = glyphs[name];
  if (!glyph) return null;
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke={active ? 'var(--royal-purple)' : '#fff'}
      strokeWidth={name === 'Exams' || name === 'Class Tasks' ? 2.2 : 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {glyph}
    </svg>
  );
}
